export default function convertOrderStatusForReport(status = '') {
  return {
    all: 'all',
    success: 'success',
    fail: 'fail',
    active: 'active',
    refund: 'refund',
  }[status];
}
